<template>
  <div class="container-fluid py-4 config-medical-page">

    <!-- ================= HEADER ================= -->
    <div class="page-header-medical d-flex justify-content-between align-items-center flex-wrap mb-4">

      <div class="title-block">
        <div class="icon-box">
          <i class="bi bi-hospital"></i>
        </div>

        <div>
          <h2 class="title">
            Configuration Système Médical
          </h2>

          <p class="subtitle">
            Gestion du stock et des paramètres de la plateforme MEDISTOCK
          </p>
        </div>
      </div>

      <!-- ACTIONS -->
      <div class="actions">

        <button
          v-if="!configuration && $store.getters.hasPermission('CREATE_CONFIGURATION_BOUTIQUE')"
          class="btn btn-primary-medical"
          @click="creer"
          :disabled="isLoading"
        >
          <i class="bi bi-plus-circle"></i>
          Nouvelle configuration
        </button>

        <button
          v-else-if="$store.getters.hasPermission('EDIT_CONFIGURATION_BOUTIQUE')"
          class="btn btn-outline-medical"
          @click="modifier"
        >
          <i class="bi bi-pencil-square"></i>
          Modifier configuration
        </button>

      </div>

    </div>

    <!-- ================= LOADING ================= -->
    <div v-if="isLoading" class="loading-box">

      <div class="spinner-border text-primary" role="status"></div>

      <p>Chargement des paramètres médicaux...</p>

    </div>

    <!-- ================= CONTENT ================= -->
    <div v-else class="card medical-card">

      <div class="card-body">

        <!-- CONFIG EXISTE -->
        <div v-if="configuration">

          <div class="status-ok mb-4">
            <i class="bi bi-check2-circle"></i>
            Configuration active du système médical
          </div>

          <div class="grid-info">

            <div class="info-item">
              <i class="bi bi-building"></i>
              <div>
                <span>Nom système</span>
                <strong>{{ configuration.nom }}</strong>
              </div>
            </div>

            <div class="info-item">
              <i class="bi bi-geo-alt"></i>
              <div>
                <span>Ville</span>
                <strong>{{ configuration.ville }}</strong>
              </div>
            </div>

            <div class="info-item">
              <i class="bi bi-pin-map"></i>
              <div>
                <span>Adresse</span>
                <strong>{{ configuration.adresse }}</strong>
              </div>
            </div>

            <div class="info-item">
              <i class="bi bi-telephone"></i>
              <div>
                <span>Contact urgence</span>
                <strong>{{ configuration.telephone }}</strong>
              </div>
            </div>

          </div>

          <div class="description-medical">
            <div class="desc-title">
              <i class="bi bi-file-medical"></i>
              Description système
            </div>

            <p>
              {{ configuration.description || 'Aucune description renseignée.' }}
            </p>
          </div>

        </div>

        <!-- VIDE -->
        <div v-else class="empty-medical">

          <i class="bi bi-hospital"></i>

          <h3>Aucune configuration médicale</h3>

          <p>
            Le système MEDISTOCK n’est pas encore configuré.
            Veuillez initialiser les paramètres pour activer la gestion du stock médical.
          </p>

        </div>

      </div>

    </div>

  </div>
</template>

<script>
import api from "@/api";

export default {
  data() {
    return {
      configuration: null,
      isLoading: true
    };
  },

  methods: {

    async getConfiguration() {
      try {
        const res = await api.getItems("configurations");
        const data = res.data.data;

        this.configuration = Array.isArray(data) ? data[0] : null;

      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
      }
    },

    creer() {
      this.$router.push({ name: "create_configuration_boutique" });
    },

    modifier() {
      this.$router.push({
        name: "edit_configuration_systeme",
        params: { id: this.configuration.id }
      });
    }

  },

  created() {
    this.getConfiguration();
  }
};
</script>

<style scoped>

/* ================= PAGE ================= */
.config-medical-page {
  background: #f4f7fb;
  min-height: 100vh;
}

/* ================= HEADER ================= */
.page-header-medical {
  background: linear-gradient(135deg, #0f4c81, #071a2e);
  padding: 22px;
  border-radius: 18px;
  color: white;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}

.title-block {
  display: flex;
  align-items: center;
  gap: 15px;
}

.icon-box {
  width: 55px;
  height: 55px;
  background: rgba(255,255,255,0.15);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}

.title {
  font-size: 1.3rem;
  font-weight: 700;
  margin: 0;
}

.subtitle {
  font-size: 0.85rem;
  opacity: 0.8;
  margin: 0;
}

/* ================= BUTTONS ================= */
.btn-primary-medical {
  background: #00c853;
  border: none;
  padding: 10px 16px;
  border-radius: 12px;
  color: white;
}

.btn-outline-medical {
  border: 1px solid #00c853;
  color: #00c853;
  background: transparent;
  padding: 10px 16px;
  border-radius: 12px;
}

/* ================= LOADING ================= */
.loading-box {
  text-align: center;
  padding: 60px 0;
}

/* ================= CARD ================= */
.medical-card {
  border: none;
  border-radius: 18px;
  margin-top: 20px;
}

/* ================= STATUS ================= */
.status-ok {
  background: #e7f8ef;
  color: #0f9d58;
  padding: 12px 15px;
  border-radius: 12px;
  font-weight: 600;
}

/* ================= GRID ================= */
.grid-info {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  margin-top: 20px;
}

.info-item {
  display: flex;
  gap: 12px;
  padding: 14px;
  background: #f8fafc;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
}

.info-item i {
  font-size: 20px;
  color: #0f4c81;
}

.info-item span {
  font-size: 0.75rem;
  color: #64748b;
}

.info-item strong {
  display: block;
  font-size: 0.95rem;
}

/* ================= DESCRIPTION ================= */
.description-medical {
  margin-top: 20px;
  padding: 16px;
  border-radius: 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.desc-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  margin-bottom: 8px;
}

/* ================= EMPTY ================= */
.empty-medical {
  text-align: center;
  padding: 50px 20px;
}

.empty-medical i {
  font-size: 60px;
  color: #0f4c81;
  margin-bottom: 10px;
}

.empty-medical h3 {
  font-weight: 700;
}

/* ================= RESPONSIVE ================= */
@media (max-width: 768px) {
  .grid-info {
    grid-template-columns: 1fr;
  }

  .page-header-medical {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
}

</style>